module.exports = __webpack_public_path__ + "static/media/pdf.dedce392.png";